import { useContext } from 'react';

import { DLocalContext } from './context';
import type { DLocalInstance } from './context';

export function useDLocal(): DLocalInstance {
	return useContext(DLocalContext);
}
